<template>
	<div class="app">

		<div class="neirong">
			<div class="left">
				<div class="li" :class="{lib:tabIndex==index}" v-for="(item,index) in leftTypeList" :key="index"
					@click="goXuanze(index)">
					<div class="icon"><i :class="item.icon"></i></div>
					<div class="text">{{item.name}}</div>
				</div>
			</div>
			<div class="right">
				<div class="title">
					{{leftTypeList[tabIndex].name}}
				</div>
				<div v-if="tabIndex==0" class="content">
					修改简介信息
				</div>
				<div v-if="tabIndex==1">
					<img class="img" @click="dialogTableVisible = true" src="../../assets/zizhi.png" alt="图片">
				</div>
				<div v-if="tabIndex==2" class="content">
					修改介绍信息
				</div>
			</div>
		</div>

		<el-dialog title="公司资质" :visible.sync="dialogTableVisible" width='1000px'>
			<img style="width: 100%;" src="../../assets/home/bg.png" alt="图片">
		</el-dialog>

	</div>
</template>

<script>
	import {
		comAgreement,
		comZizhi,
		comXc
	} from "@/api/user";
	export default {
		data() {
			return {
				leftTypeList: [{
					name: '公司简介',
					icon: 'el-icon-tickets',
					id: 1
				}, {
					name: '公司资质',
					icon: 'el-icon-document-checked',
					id: 2
				}, {
					name: '软件介绍',
					icon: 'el-icon-goods',
					id: 4
				}],
				tabIndex: 0,
				dialogTableVisible: false
			}
		},
		mounted() {},
		methods: {
			goXuanze(ind) {
				this.tabIndex = ind
			}
		}
	};
</script>

<style scoped lang="less">
	.app {
		width: 100%;
	}

	.neirong {
		width: 1300px;
		position: relative;
		margin: 0 auto;
		display: flex;
		justify-content: space-between;
		padding: 40px 0;

		.left {
			width: 300px;
			height: 170px;
			border-radius: 10px;
			background-color: #FFF;
			overflow: hidden;
			border: 2px solid #E7E7E7;

			.li {
				display: flex;
				align-items: center;
				font-size: 16px;
				color: #333333;

				padding: 15px 0;
				border-bottom: 2px solid #E7E7E7;
				cursor: pointer;

				.icon {
					margin: 0 10px 0 20px;
					font-size: 20px;
				}

				.text {
					margin-left: 10px;
				}
			}

			.li:last-child {
				border-bottom: none;
			}

			.lib {
				background-color: #FF7E7F;
				color: #FFF;
			}
		}

		.right {
			width: 950px;
			background: #FFFFFF;
			border: 2px solid #E7E7E7;
			border-radius: 10px;
			padding: 20px;
			position: relative;
			box-sizing: border-box;

			.title {
				font-size: 18px;
				font-family: PingFang SC;
				font-weight: bold;
				color: #333333;
				border-left: 4px solid #FF7E7F;
				padding-left: 15px;
				margin-bottom: 20px;

			}

			.content {
				word-wrap: break-word;
				white-space: pre-line;
			}

			.zizhiList {
				position: relative;

				.img {
					height: 250px;
					float: left;
					margin-right: 20px;
				}
			}

			.img {
				width: 100%;
			}

			.shipinList {
				position: relative;

				.video {
					height: 450px;
					float: left;
					margin-right: 20px;
				}
			}
		}
	}

	/deep/ .el-message-box {
		width: auto !important;
	}
</style>


// WEBPACK FOOTER //
// src/views/guanyu/guanyu.vue